import { Container, Row, Col, ProgressBar } from 'react-bootstrap';
import {
  HeadingDescSmall,
  SectionHeadingXtraLarge
} from '../../../Components/Headings';
import HealthCheckLayout from '../healthCheckLayout/HealthCheckLayout';
import AddMember from '../../../Components/addMember/AddMember';
import cameraRecording from '../../../assets/images/png/camera-rec.png';
import { HealthResultCards } from '../../../Components/Card';
import './scanStarted.css';

// const results = [
//   { result: 56 },
//   { result: 40 },
//   { result: 76 },
//   { result: 88 },
//   { result: 'Low' },
//   { result: 4 }
// ];

const results = [56, 40, 76, 88, 'Low', 4];
const check = results.map((item) => item);

function ScanStarted() {
  return (
    <HealthCheckLayout>
      <section className="scanStarted bgLinghtGray">
        <Container>
          <Row>
            <Col md={8}>
              <div className="leftBox cameraRecording">
                <img src={cameraRecording} alt="cameraRecording" />
                <HealthResultCards result={check} />
                <ProgressBar now={30} />
              </div>
            </Col>
            <Col md={4}>
              <div className="rightBox">
                <div className="whiteBox">
                  <AddMember />
                </div>
                <hr />
                <div className="whiteBox">
                  <HeadingDescSmall text="Your Vitals" />
                  <HeadingDescSmall text="The HealthCheck Scan will last for 90 second before it can show you the vitals." />
                </div>
                <div className="whiteBox">
                  <HeadingDescSmall text="Remaining Time" />
                  <SectionHeadingXtraLarge text="01:15" />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </HealthCheckLayout>
  );
}

export default ScanStarted;
